import { render, staticRenderFns } from "./TranProgramModuleListFilter.vue?vue&type=template&id=1a63e304&scoped=true"
import script from "./TranProgramModuleListFilter.vue?vue&type=script&lang=js"
export * from "./TranProgramModuleListFilter.vue?vue&type=script&lang=js"
import style0 from "./TranProgramModuleListFilter.vue?vue&type=style&index=0&id=1a63e304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a63e304",
  null
  
)

export default component.exports